const documentation = `# Delay node

The Delay node is used to introduce a delay in the execution of the flow. It has one obligatory parameter, which is the delay is seconds.

This parameter is evaluated, thus you can use variables as well (e.g. \`{x}\` where x is 3, will result in 3 seconds of delay).

`;

export default documentation;
